import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // 페이지(path)가 바뀔 때마다 실행
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto", // or "smooth" 원하면 부드럽게
        });
    }, [pathname]);

    return null; // 화면에 아무것도 안 그림
}